export default function MatchCheckIcon({ width = 11, height = 8, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M0.5 3.83333L3.83333 7.16667L10.5 0.5' stroke='#021320' strokeOpacity='0.75' strokeLinecap='round' />
    </svg>
  );
}
